import { action as apiAction } from 'api/Api'
import {
  set as setElement,
} from '../redux/elements'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number;
  documentFolderId: number;
  settings: any
}

const requestChangeDocumentFolderSettings = (payload: Payload) => async (dispatch, getState) => {
  const { cardId, documentFolderId, settings } = payload

  const currentSettings = getState()['view-card'].elements.elementsById[documentFolderId]?.settings

  const newSettings = {
    ...currentSettings,
    ...settings
  }

  const optimisticAction = optimisticDispatch(dispatch, setElement({
    cardId,
    element: {
      id: documentFolderId,
      settings: newSettings,
    }
  }))

  try {
    await apiAction('ChangeDocumentFolderSettings', {
      documentFolderId,
      settings: newSettings
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    throw error
  }
}

export default requestChangeDocumentFolderSettings